import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class ProductsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/products", { params: toSnakeCase(params) });
  }

  fetch(id, params) {
    return securedAxiosInstance.get(`/products/${id}`, { params: toSnakeCase(params) });
  }

  enable(productIds) {
    return securedAxiosInstance.post("/products/enable", toSnakeCase({ productIds }));
  }

  disable(productIds) {
    return securedAxiosInstance.post("/products/disable", toSnakeCase({ productIds }));
  }
}

export default new ProductsService();
